import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { clearSupabaseAuthTokens } from './lib/supabase'

// ── Global guard: catch stale/invalid refresh token errors ──────────────────
// When Supabase auto-refresh fails (e.g. token revoked or expired on server),
// it throws an unhandled promise rejection. We intercept it here, wipe the
// cached tokens and reload so the user lands on the login screen cleanly.
window.addEventListener('unhandledrejection', (event) => {
  const msg: string = (event?.reason?.message ?? event?.reason ?? '').toString().toLowerCase();
  if (
    msg.includes('refresh token not found') ||
    msg.includes('invalid refresh token') ||
    msg.includes('refresh_token_not_found')
  ) {
    console.warn('[App] Refresh token inválido detectado — limpando sessão');
    event.preventDefault();
    clearSupabaseAuthTokens();
    // Small delay to let any pending state updates settle
    setTimeout(() => {
      window.location.reload();
    }, 300);
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
